<template>
<div class="chapter">
<div class="inner_page">
<h1 class="toc">CONTENTS</h1>
<p class="nonindent"><a class="hlink" href="#/OEBPS/9780062028976_epub_prl_r1.htm" id="prl">PROLOGUE: SANTIAGO DE CUBA</a></p>
<p class="nonindent"><a class="hlink" href="#/OEBPS/9780062028976_epub_c01_r1.htm" id="c01">1 NEW YORK CITY</a></p>
<p class="nonindent"><a class="hlink" href="#/OEBPS/9780062028976_epub_c02_r1.htm" id="c02">2 HAVANA, CUBA</a></p>
<p class="nonindent"><a class="hlink" href="#/OEBPS/9780062028976_epub_c03_r1.htm" id="c03">3</a></p>
<p class="nonindent"><a class="hlink" href="#/OEBPS/9780062028976_epub_c04_r1.htm" id="c04">4</a></p>
<p class="nonindent"><a class="hlink" href="#/OEBPS/9780062028976_epub_c05_r1.htm" id="c05">5</a></p>
<p class="nonindent"><a class="hlink" href="#/OEBPS/9780062028976_epub_c06_r1.htm" id="c06">6</a></p>
<p class="nonindent"><a class="hlink" href="#/OEBPS/9780062028976_epub_c07_r1.htm" id="c07">7</a></p>
<p class="nonindent"><a class="hlink" href="#/OEBPS/9780062028976_epub_c08_r1.htm" id="c08">8</a></p>
<p class="nonindent"><a class="hlink" href="#/OEBPS/9780062028976_epub_c09_r1.htm" id="c09">9</a></p>
<p class="nonindent"><a class="hlink" href="#/OEBPS/9780062028976_epub_c10_r1.htm" id="c10">10</a></p>
<p class="nonindent"><a class="hlink" href="#/OEBPS/9780062028976_epub_c11_r1.htm" id="c11">11</a></p>
<p class="nonindent"><a class="hlink" href="#/OEBPS/9780062028976_epub_c12_r1.htm" id="c12">12</a></p>
<p class="nonindent"><a class="hlink" href="#/OEBPS/9780062028976_epub_c13_r1.htm" id="c13">13</a></p>
<p class="nonindent"><a class="hlink" href="#/OEBPS/9780062028976_epub_c14_r1.htm" id="c14">14</a></p>
<p class="nonindent"><a class="hlink" href="#/OEBPS/9780062028976_epub_c15_r1.htm" id="c15">15</a></p>
<p class="nonindent"><a class="hlink" href="#/OEBPS/9780062028976_epub_c16_r1.htm" id="c16">16</a></p>
<p class="nonindent"><a class="hlink" href="#/OEBPS/9780062028976_epub_c17_r1.htm" id="c17">17</a></p>
<p class="nonindent"><a class="hlink" href="#/OEBPS/9780062028976_epub_c18_r1.htm" id="c18">18</a></p>
<p class="nonindent"><a class="hlink" href="#/OEBPS/9780062028976_epub_c19_r1.htm" id="c19">19</a></p>
<p class="nonindent"><a class="hlink" href="#/OEBPS/9780062028976_epub_c20_r1.htm" id="c20">20</a></p>
<p class="nonindent"><a class="hlink" href="#/OEBPS/9780062028976_epub_c21_r1.htm" id="c21">21</a></p>
<p class="nonindent"><a class="hlink" href="#/OEBPS/9780062028976_epub_c22_r1.htm" id="c22">22</a></p>
<p class="nonindent"><a class="hlink" href="#/OEBPS/9780062028976_epub_c23_r1.htm" id="c23">23</a></p>
<p class="nonindent"><a class="hlink" href="#/OEBPS/9780062028976_epub_c24_r1.htm" id="c24">24</a></p>
<p class="nonindent"><a class="hlink" href="#/OEBPS/9780062028976_epub_c25_r1.htm" id="c25">25</a></p>
<p class="nonindent"><a class="hlink" href="#/OEBPS/9780062028976_epub_ack_r1.htm" id="ack">ACKNOWLEDGMENTS</a></p>
<p class="nonindent"><a class="hlink" href="#/OEBPS/9780062028976_epub_col1_r1.htm" id="col1">Books by William Heffernan</a></p>
<p class="nonindent"><a class="hlink" href="#/OEBPS/9780062028976_epub_bm1_r1.htm" id="bm1">Please turn the page for an early look at</a></p>
<p class="nonindent"><a class="hlink" href="#/OEBPS/9780062028976_epub_bm2_r1.htm" id="bm2">1</a></p>
<p class="nonindent"><a class="hlink" href="#/OEBPS/About_the_Author.htm" id="abt">About the Author</a></p>
<p class="nonindent"><a class="hlink" href="#/OEBPS/9780062028976_epub_fm1_r1.htm" id="fm1">Praise for Edgar Award-winner: WILLIAM HEFFERNAN: and: RED ANGEL</a></p>
<p class="nonindent"><a class="hlink" href="#/OEBPS/9780062028976_epub_cop_r1.htm" id="cop">Copyright</a></p>
<p class="nonindent"><a class="hlink" href="#/OEBPS/About_the_Publisher.htm" id="pub">About the Publisher</a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780062028976_epub_toc_r1.vue?1180685a